import { CarbonComparisonRequest, FieldModel, MpxResponseError, TillageType } from '@cibo/core'
import { GridRowId } from '@mui/x-data-grid-pro'
import { UseQueryResult } from '@tanstack/react-query'
import { createContext, useContext } from 'react'
import { useCarbonLabPractices } from './queries'

export interface CarbonLabState {
  comparisonQuery: CarbonComparisonRequest
  resetComparisonQuery: () => void
  setComparisonQuery: (query: CarbonComparisonRequest) => void
  selectedFields: GridRowId[]
  navigateToLab: () => void
  isPresent: boolean
}

export const CarbonLabContext = createContext<CarbonLabState>({
  comparisonQuery: {
    resourceIds: [],
    baselinePracticesName: 'ActualPractices',
    practicesName: 'RegionalPractices',
    fertilizerReduction: 1,
    hasCoverCrop: false,
    tillage: TillageType.CONVENTIONAL_TILLAGE,
  },
  resetComparisonQuery: console.log,
  setComparisonQuery: console.log,
  selectedFields: [],
  navigateToLab: console.log,
  isPresent: false,
})
CarbonLabContext.displayName = 'CarbonLabContext'

export const DEFAULT_CARBON_COMPARISON_QUERY = {
  resourceIds: [],
  baselinePracticesName: 'ActualPractices',
  practicesName: 'RegionalPractices',
  fertilizerReduction: 1,
  hasCoverCrop: false,
  tillage: TillageType.CONVENTIONAL_TILLAGE,
} as CarbonComparisonRequest

export interface UseCarbonLabState extends CarbonLabState {
  result?: UseQueryResult<FieldModel | undefined, MpxResponseError>
}

export const useCarbonLab = () => {
  const context = useContext(CarbonLabContext)
  const practices = useCarbonLabPractices()
  return {
    ...context,
    practices,
  }
}
